module.exports = __webpack_public_path__ + "static/media/help.db788032.svg";